import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aa043d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-panel" }
const _hoisted_2 = {
  key: 0,
  class: "label required-container"
}
const _hoisted_3 = { class: "title-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line-filler" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "required-label"
}
const _hoisted_6 = { key: 1 }


export default /*#__PURE__*/_defineComponent({
  __name: 'group-fieldset-component',
  props: {
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    default: undefined,
  },
  /**
   * Whether the layout is column or row.
   * @type {string}
   * @default 'column'
   */
  layout: {
    type: String,
    default: "column",
  },
  /**
   * Whether group should have a required tag.
   * @type {boolean}
   * @default false
   */
  isRequired: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1),
          _hoisted_4,
          (__props.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "One required"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.isRequired)
      ? (_openBlock(), _createElementBlock("legend", _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["panel-content", `layout-${__props.layout}`])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})